import React, { useEffect, useLayoutEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Authentication, useToken } from '@samc/auth-authentication-okta';
import { Authorization, } from '@samc/auth-authorization';
import '@samc/centricity-core/dist/style.css';
import "@samc/auth-authorization/index.css";
import "@samc/auth-authentication-okta/index.css";
import { SiteContent } from "./SiteContent.react";

const app = document.getElementById('main-content');

const configJson = app ? app.dataset["authConfig"] : null;
const config = configJson ? JSON.parse(configJson) : null;

const PassTokenToAuthorization = () => {
  const token = useToken();

  return (
      <Authorization config={config} jwt={token}>
            <SiteContent />
      </Authorization>
    );
}

const AuthWithAntiforgeryToken = () => {
  const [authConfig, setAuthConfig] = useState(undefined);

  useLayoutEffect(() => {
    const configHeaders = async () => {

      const antiforgeryToken = await window.$verificationToken();

      config.defaultHeaders = {
        "RequestVerificationToken": antiforgeryToken
      };

      setAuthConfig(config);
    };

    configHeaders();

  }, []);

  return (
    <div>
      {authConfig &&
        <Authentication config={authConfig} >
          <PassTokenToAuthorization />
        </Authentication >
      }
    </div>
  );
}

if (config) {
    // Config was found and parsed, so we're presumably running SitusAMC Auth.
    ReactDOM.render(
      <React.StrictMode>
        <AuthWithAntiforgeryToken />
      </React.StrictMode>,
      document.getElementById('authSection')
    );
} else {
    // Config wasn't found, so we need to hide authSection and display the main <article />
    document.getElementById("body").classList.remove("hidden");
    document.getElementById("authSection").classList.add("hidden");
}